// Centralized route bases.
// The authenticated ERP lives under /app/*, the public marketing landing page
// at /, login at /login, and the client portal under /portal/*.
export const APP_BASE = "/app";
export const PORTAL_BASE = "/portal";

// Prefix an in-app ERP path with the app base.
// Accepts "/milk", "milk", "/productions?expiring=1", or "" (=> "/app").
export const appPath = (p = "") => {
  if (!p || p === "/") return APP_BASE;
  const s = String(p);
  return s.startsWith("/") ? `${APP_BASE}${s}` : `${APP_BASE}/${s}`;
};

// True when the given pathname is inside an authenticated area (ERP or portal).
export const isProtectedPath = (pathname = "") =>
  pathname.startsWith(APP_BASE) || pathname.startsWith(PORTAL_BASE);
